import { gql } from 'apollo-boost'

export const GET_PUBLISHED_POSTS_QUERY = gql`
  query publishedPosts($limit: Int!, $offset: Int!) {
      publishedPosts(limit: $limit, offset: $offset) {
          title
          slug
          createdAt
          coverImage {
              path
              filename
              id
          }
      }
  }
`;

export const GET_PUBLISHED_EVENTS_QUERY = gql`
    query publishedEvents {
        publishedEvents {
            title
            slug
            createdAt
            coverImage {
                path
                filename
                id
            }   
        }
    }
`;

export const GET_POST_QUERY = gql`
    query postBySlug($slug: String!) {
        postBySlug(slug: $slug) {
            author {
                firstName
                lastName
            }
            content
            createdAt
            title
            categories {
                id
                name
            }
        }
    }
`;

export const NEW_REQUEST_APPLICATION_MUTATION = gql`
    mutation newRequestApplication($firstName: String!, $lastName: String!, $email: String!, $website: String, $message: String){
        newApplicationRequest(firstName: $firstName, lastName: $lastName, email: $email, website: $website, message: $message)
    }
`;
